export const SIGNIN_LINK = `${process.env.REACT_APP_REIMBUCKS_WEB}/signin`;
export const SIGNUP_LINK = `${process.env.REACT_APP_REIMBUCKS_WEB}/signup`;
export const PLAYSTORE_LINK = process.env.REACT_APP_PLAYSTORE_URL;
export const APPSTORE_LINK = process.env.REACT_APP_APPSTORE_URL;
export const TERMS_LINK = '/terms';
export const PRIVACY_LINK = '/privacy';
export const CONTACT_LINK = '/contact';
